import React, { useContext, useMemo, useState } from 'react';
import { CompanyContext } from '../../../../context/CompanyContext';
import { storeCurrentCompanyId } from '../../../../util/token.util';
import { useNavigate } from 'react-router-dom';
import CreateCompanyModal from './Modals/CreateCompanyModal';
import { useMutation } from '@apollo/client';
import { UtilQueries } from '../../../../graphql/util.graphql';
import { SuperUserContext } from '../../../../context/SuperUserContext';
import {
  CompanyMutations,
  CreateDemoCompanyResponse,
  CreateDemoCompanyVariables,
} from '../../../../graphql/company.graphql';
import CompanyCard from '../../../components/CompanyCard/CompanyCard';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { SearchFilter } from '../../../components/Filter';
import { CompanyFilter } from '../../../../VentoryUI/components/filters/CompanyFilter/CompanyFilter';
import { Company } from '../../../../types/company';
import { Button } from '../../../components/Button/Button';

export default function AdministratorCompanyPane() {
  const navigate = useNavigate();
  const { companies, refreshCompany } = useContext(CompanyContext);
  const { superUser } = useContext(SuperUserContext);

  const [items, setItems] = useState(Array.from(companies.values()));
  const [openCreateModal, setOpenCreateModal] = useState<boolean>(false);

  const [refreshCompanyCache, { loading }] = useMutation(UtilQueries.refreshCompanyCache, {
    onError: err => console.log(err.message),
  });

  const [createDemoCompany, { loading: demoLoading }] = useMutation<
    CreateDemoCompanyResponse,
    CreateDemoCompanyVariables
  >(CompanyMutations.createDemo, {
    onCompleted: async res => {
      const company = res.createDemoCompany;
      storeCurrentCompanyId(company.id);
      await refreshCompany(company.id);
      navigate('/dashboard');
    },
  });

  const allItems = useMemo(() => {
    return Array.from(companies.values());
  }, [companies]);

  const filter = new CompanyFilter();

  const handleClick = (company: Company) => {
    storeCurrentCompanyId(company.id);
    refreshCompany(company.id);
    navigate('/dashboard');
  };

  return (
    <>
      <CreateCompanyModal open={openCreateModal} setOpen={setOpenCreateModal} />

      <div className='content-b-screen flex h-full flex-col'>
        <div className='content-x flex justify-between'>
          <SearchFilter
            placeholder={t(TranslationKey.filter).singular.label}
            items={allItems}
            setItems={setItems}
            filter={filter}
          />
          <div className='flex gap-2'>
            <Button
              loading={loading}
              onClick={() => createDemoCompany()}
              text={t(TranslationKey.createDemoCompany).singular.label}
            />
            <Button
              loading={loading}
              onClick={() => setOpenCreateModal(true)}
              text={t(TranslationKey.createCompany).singular.label}
            />
          </div>
        </div>
        <div className='content-x flex flex-wrap gap-4 overflow-y-auto py-4'>
          {items
            .sort((a, b) => (a.partner ? 0 : 1) - (b.partner ? 0 : 1) || a.name.localeCompare(b.name))
            .map(company => (
              <CompanyCard key={company.id} company={company} onClick={() => handleClick(company)} />
            ))}
        </div>
      </div>
      <div className='flex flex-wrap gap-4 overflow-y-auto p-2'>
        {items
          .sort((a, b) => (a.partner ? 0 : 1) - (b.partner ? 0 : 1) || a.name.localeCompare(b.name))
          .map(company => (
            <CompanyCard key={company.id} company={company} onClick={() => handleClick(company)} />
          ))}
      </div>
    </>
  );
}
